export default __webpack_public_path__ + "static/media/icon-infusion-per-time.55747127.svg";